import React from "react";
import { Button } from "primereact/button";
import { FileUpload } from "primereact/fileupload";
import { useParams } from "react-router-dom";

export default function CustomButton({
  label = "Submit",
  extraClassName,
  hideIfNoId = false,
  ...props
}) {
  const { id } = useParams();
  if (hideIfNoId && !id) return null;
  return (
    <Button
      className={`text-lg button-bg align-center border-none mt-0 ${extraClassName}`}
      label={label}
      style={{ alignSelf: "center" }}
      {...props}
    />
  );
}

export const OutlineCustomButton = ({
  label,
  icon,
  extraClassName,
  onClick,
}) => {
  return (
    <Button
      label={label}
      icon={icon}
      className={`text-base outline-btn font-normal ${extraClassName}`}
      onClick={() => onClick && onClick()}
    />
  );
};

export function CustomButtonOutlined({
  label = "Submit",
  extraClassNames,
  ...props
}) {
  return (
    <Button
      className={`text-lg outline-btn font-normal ${extraClassNames}`}
      label={label}
      style={{ alignSelf: "center" }}
      outlined
      {...props}
    />
  );
}

export function Buttonlayout({ className, position = "center", children }) {
  return (
    <div className={`gap-2 flex my-2 justify-content-${position} ${className}`}>
      {children}
    </div>
  );
}

export function RoundButton({
  label = "Submit",
  extraClassName,
  onClick,
  ...props
}) {
  return (
    <Button
      label={label}
      style={{
        borderRadius: "100px",
        display: "flex",
        background: "#545933",
        color: "#FFFFFF",
        border: "none",
      }}
      onClick={() => onClick && onClick()}
      {...props}
    />
  );
}

export function OutlineRoundButton({
  label = "Submit",
  extraClassName,
  ...props
}) {
  return (
    <Button
      label={label}
      extraClass="border-1 border-[#96A13D] border-round-3xl text-[#96A13D] "
      style={{ color: "#96A13D", borderRadius: "100px" }}
      outlined
      {...props}
    />
  );
}

export function CustomFileuploadButton({
  label = "Upload Document",
  accept = ".jpeg, .jpg, .png, .pdf",
  onChange,
  name,
  isMulitple,
  inputKey,
}) {
  return (
    <>
      <Button
        label={label}
        className={`bg-main upload-btn py-3 relative border-none border-round-3xl cursor-pointer`}
        icon={"pi pi-plus"}
      >
        <input
          type="file"
          name={name}
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0",
            left: "0",
            opacity: "0",
            cursor: "pointer",
          }}
          id="file-upload"
          key={inputKey}
          accept={accept}
          onChange={(e) => {
            onChange &&
              onChange({ ...e, name: name, value: e?.target?.files[0] });
          }}
          multiple={isMulitple}
        />
      </Button>
    </>
  );
}
